import React, {useState} from 'react'
import {Button, Modal, Radio, Input, Space} from 'antd'
import {ModalCloseIco} from '../../../modules/CustomIcons'

import './index.scss'
import {useHistory} from "react-router-dom";
import { useTranslation } from 'react-i18next';



const CreateNewTemplateModal: React.FC<any> = (props : any) => {
    const {t} = useTranslation();
    const options=[
        { label: t("home.internal"), value: 1, url: '/new_transfer/inside_bank'  },
        { label: t("home.domesticAZN"), value: 2, url : '/new_transfer/domestic'},
        { label: t("home.foreignCurrency"), value: 3, url : '/new_transfer/foreign_currency'},
        { label: "AniPay", value: 4, url : '/new_transfer/anipay'}
    ]

    const [optionValue, setOptionValue] = useState(1);
    const [selectedOptionRow, setSelectedOptionRow] = useState(options.find(row => row.value==optionValue));
    const history=useHistory();



    const onClose = () => {
        props.onClose((old_value) => false)
    }

    const onOptionsChange= (e) =>{
        const new_val=e.target.value;
        const selected_option=options.find(row => row.value==new_val);

        setOptionValue(old_value => new_val);
        setSelectedOptionRow(old_data => selected_option);
    }

    const goToTransferPage = () => {
        history.push({
            pathname: selectedOptionRow?.url
        })
    }

    const modalFooter = () => (
        <>
            <div className='flex justify_end align_center'>
                <Button type="button" className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center" onClick={onClose} >{t("settings.deactivate")}</Button>
                <Button type="button" className="blue-button next_btn btn flex align_center justify_center"  onClick={goToTransferPage} >{t("newTransfer.nextButton")}</Button>
            </div>
        </>
    )

  return (
    <>
        {
            <Modal
                title={t("transfers.transferType")}
                closeIcon={<ModalCloseIco />}
                centered
                visible={props.visible}
                onCancel={onClose}
                width={540}
                className={` manage_faster_menus create_new_template_modal no_footer  ${props?.className}`}
                keyboard={false}
                focusTriggerAfterClose={false}
                footer={modalFooter()}
            >

                <div className={'full flex align_center create_template_modal_body'}>

                    <Radio.Group
                        className={'go_to_template_options'}
                        value={optionValue}
                        onChange={onOptionsChange}
                    >
                        <Space direction={"vertical"} >
                            {
                                options.map(row => {
                                    return (
                                        <Radio value={row.value} >{row.label}</Radio>
                                    )
                                })
                            }
                        </Space>
                    </Radio.Group>


                </div>

            </Modal>
        }
    </>
  )
}

export default CreateNewTemplateModal
